import { html, SYSBaseElement, SYSTableDefIds } from "../../../../.."
import { T } from "../../../../../textapi"
import { SYSTableSettings_ColumnFilter } from "../columnfilter/tabledef"

import { _GetRowDisplayValue, _GetRowRawValue } from "../../../helpers"
import { _ColumnColumnFilter } from "../../../table"
import {
  SYSTableDef,
  TableColumnFilter,
  TableGet,
  _TableGetReturnType,
  TableOpenColumnFilter,
  TableRebuild,
} from "../../../tableapi"
import { FormGet } from "../../../../forms/formapi"
import { HeaderMenuFilterFieldsSetState } from "../hookactions"

export class SYSHeaderMenuColumnFilter extends SYSBaseElement {
  defId: SYSTableDefIds
  columnKey: string
  tableDef: _TableGetReturnType<SYSTableSettings_ColumnFilter>
  filter: _ColumnColumnFilter
  baseRows: {}
  baseDef: SYSTableDef

  getDisplayValue() {
    if (this.filter.type === "none") {
      return T("SYSFilterAll")
    }
    let list = []
    let nullHandling = this.baseDef.columns[this.columnKey].nullHandling.enabled
    // let isCalculated =
    //   this.baseDef.columns[this.columnKey].schema?.isCalculatedColumn
    if (this.filter.list) {
      this.filter.list.slice(0, 100).forEach((k) => {
        let foundRowKey = undefined
        Object.keys(this.baseRows).some((s) => {
          let val
          if (this.tableDef.def.columns[this.columnKey].list) {
            val = this.baseRows[s][this.columnKey]
          } else {
            val = _GetRowRawValue(
              this.baseDef,
              this.columnKey,
              this.baseRows[s],
              s,
              "ColumnFilter"
            )
          }

          if (val === k || (!nullHandling && k === "" && val === null)) {
            foundRowKey = s
            return true
          }
        })
        if (foundRowKey === undefined) {
          list.push(k)
        }
        if (foundRowKey !== undefined) {
          let val = _GetRowDisplayValue(
            this.baseDef,
            this.columnKey,
            this.baseRows[foundRowKey],
            foundRowKey,
            "ColumnFilter"
          )

          if (val === null) {
            list.push(T("SYSFilterNull"))
            return
          }
          if (val === "") {
            list.push(T("SYSFilterEmpty"))
            return
          }

          list.push(val)
        }
      })
    }

    return html`${this.filter.exclusive
      ? T("SYSFilterExclusive") + ": "
      : ""}${list.map((m, i) => html`${m}${i < list.length - 1 ? ", " : ""}`)}`
  }

  async openAdvancedColumnFilter() {
    await TableOpenColumnFilter(this.defId, this.columnKey, {
      allowExclusive: true,
    })
  }
  async init() {
    this.tableDef = TableGet<SYSTableSettings_ColumnFilter>(this.defId)
    let baseTable = TableGet(this.defId)
    this.baseDef = baseTable.def
    this.baseRows = baseTable.rows
    await super.init()
  }
  async getUI() {
    this.filter =
      this.tableDef.def.uiState.filter.columns[this.columnKey].columnFilter

    let isForced =
      this.baseDef.uiState.filter._forced?.forcedColumnFilters?.[
        this.columnKey
      ] !== undefined

    let columnRangeFilter = this.baseDef.uiState.filter.columns[this.columnKey]?.rangeFilter
    let isRangeFilterActive = columnRangeFilter !== undefined && columnRangeFilter.selected !== undefined && columnRangeFilter.selected !== "none"
    let isColumnFilterDisabled = isForced || isRangeFilterActive

    let clearFilterButton = html`<button
      @click=${async (e) => {
        if (
          await TableColumnFilter(this.tableDef.def.id, this.columnKey, [], {
            exclusive: false,
            _innerEvent: true,
          })
        ) {
          await TableRebuild(this.tableDef.def.id, { showProcess: true })
          HeaderMenuFilterFieldsSetState(
            FormGet("SYSHeaderMenuFilter", { instance: "1" }).formState
          )
        }
      }}
      class="fd-button"
      ?disabled=${this.filter.type === "none" || isColumnFilterDisabled}
    >
      <i class="sap-icon--clear-filter"></i>
    </button>`

    this.filter =
      this.tableDef.def.uiState.filter.columns[this.columnKey].columnFilter

    return html`<div class="ovl-headermenufiltersortsettings">
      <div
        class="fd-input __columnFilterList"
        type="text"
        ?disabled=${isColumnFilterDisabled}
        @click=${async () => {
          if (!isColumnFilterDisabled) {
            await this.openAdvancedColumnFilter()
          }
        }}
        readonly
      >
        ${this.getDisplayValue()}
      </div>

      <div class="fd-segmented-button" role="group" aria-label="Tablefilter">
        ${clearFilterButton}
        <button
          class="fd-button"
          ?disabled=${isColumnFilterDisabled}
          @click=${async () => {
            await this.openAdvancedColumnFilter()
          }}
        >
          <i class="sap-icon--overflow"></i>
        </button>
      </div>
    </div> `
  }
}
